import { CompanyScope, Perms, UserRole } from '@playq/octopus2-auth';

import type { IAuthState } from './types';

const companyPerms = new Perms();
companyPerms.scope = new CompanyScope();
companyPerms.access = {};

export const initialState: IAuthState = {
  loggedIn: false,
  isServicesAuthorizationSet: false,
  company: {
    website: undefined,
    name: '',
    description: undefined,
    id: 0,
    address: undefined,
    phone: undefined,
    servicesId: '',
    routeName: '',
  },
  companyPerms: companyPerms.serialize(),
  user: {
    role: '',
    name: '',
    email: '',
    id: '',
    deleted: undefined,
    mfa: undefined,
  },
  tokens: {
    access: '',
    refresh: '',
  },
  role: UserRole.None,
  pending: false,
  rememberMe: true,
  mfa: undefined,
};
